export const JSON_ONE21 = {
   
  
        "me_id": "040721140456",
    "acc_creation_datetime": "Sep 22, 2021 12:38:05 PM",
    "status": "Inactive",
    "status_code": "0",
    "description": "Virtual Account Number Created successfully!",
    "virtual_acc_no": "9876546423456543",
    "ag_order_id": "49298951"
        }

